import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ExternalLink, Heart, Video, BookOpen, Award } from "lucide-react";

const ROST = () => {
  const mediaLinks = [
    {
      title: "Emisiune TVR 1 - Chip și asemănare",
      description: "Despre calea duhovnicească a Iulianei Mateescu",
      url: "https://www.youtube.com/watch?v=axcjmTREr44",
      type: "video"
    },
    {
      title: "Activitatea atelierelor Idaco",
      description: "O activitate născută din credință - Interviu Creștin Ortodox",
      url: "http://www.crestinortodox.ro/interviuri/dar-din-har-poveste-succes-70510.html",
      type: "article"
    },
    {
      title: "Mărturie în cuvânt și chip",
      description: "Articol despre cea mai importantă lucrare a Olgăi Greceanu",
      url: "http://www.crestinortodox.ro/reportaj/olga-greceanu-marturie-cuvant-chip-125010.html",
      type: "article"
    },
    {
      title: "TRINITAS TV - Credință și Cultură",
      description: "Dialog despre proiectul Restituiri - Valori de patrimoniu ale spiritualității ortodoxe vâlcene",
      url: "https://www.youtube.com/watch?v=7aKS3H5Ph4Y",
      type: "video"
    },
    {
      title: "TRINITAS TV - Moștenirea Brâncovenească",
      description: "Despre filmul Un chip de lumină, Arhimandritul Ioan",
      url: "https://www.youtube.com/watch?v=jzNR9GuDl8Y",
      type: "video"
    },
    {
      title: "Distincția Crucea Maria Brâncoveanu",
      description: "Oferită Iulianei Mateescu pentru filmele realizate în 2014",
      url: "http://basilica.ro/ordinul-crucea-maria-brancoveanu-pentru-doamna-iuliana-mateescu/",
      type: "award"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-burgundy/5 to-background -z-10" />
        <div className="absolute top-20 right-10 w-[500px] h-[500px] bg-primary/10 rounded-full blur-3xl -z-10 animate-float" />
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl -z-10 animate-float" style={{ animationDelay: '1s' }} />
        
        <div className="container mx-auto max-w-5xl text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary/10 backdrop-blur-sm border border-primary/20 text-primary mb-8 animate-fade-in">
            <Heart className="w-5 h-5 fill-current" />
            <span className="text-sm font-semibold font-lora">Misiune culturală și spirituală</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-8 leading-tight animate-fade-in text-primary font-playfair" style={{ animationDelay: '0.2s' }}>
            Asociația R.O.S.T
          </h1>
          
          <h2 className="text-3xl md:text-4xl font-semibold text-burgundy mb-8 animate-fade-in font-playfair" style={{ animationDelay: '0.3s' }}>
            Renașterea Obiceiurilor și Tradițiilor Românești
          </h2>
          
          <p className="text-xl md:text-3xl text-muted-foreground mb-8 leading-relaxed animate-fade-in max-w-4xl mx-auto font-lora" style={{ animationDelay: '0.4s' }}>
            O misiune dedicată păstrării și promovării valorilor spirituale și culturale ale neamului românesc prin cărți, filme și proiecte documentare
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-24 px-4 bg-gradient-to-b from-background to-cream/20">
        <div className="container mx-auto max-w-7xl">
          <div className="grid md:grid-cols-2 gap-20 items-center">
            <div className="space-y-8 animate-fade-in">
              <h2 className="text-5xl md:text-6xl font-bold leading-tight text-primary font-playfair">
                Misiunea noastră
              </h2>
              
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-lora">
                Asociația <strong>Renașterea Obiceiurilor și Tradițiilor Românești (R.O.S.T)</strong> este o organizație cultural-educativă și socială, nepartinică, neguvernamentală și non-profit, dedicată contribuției la renașterea moral-spirituală și social-culturală a românilor de pretutindeni.
              </p>
              
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-lora">
                Prin proiectele noastre culturale urmărim promovarea valorilor naționale, valorificarea creatoare a tradiției românești, prezervarea identității naționale și trezirea unei conștiințe colective a demnității noastre ca popor.
              </p>

              <div className="pt-6 p-8 bg-gradient-to-br from-primary/10 to-burgundy/10 rounded-2xl border-2 border-primary/20">
                <p className="text-foreground font-bold mb-4 text-xl font-playfair">
                  Contact
                </p>
                <div className="space-y-3 font-lora text-lg">
                  <p className="text-muted-foreground">
                    <strong>Email:</strong> idaco_traditional@yahoo.com
                  </p>
                  <p className="text-muted-foreground">
                    <strong>Telefon:</strong> +40 722 637 470
                  </p>
                </div>
              </div>
            </div>

            <div className="relative group animate-fade-in" style={{ animationDelay: '0.3s' }}>
              <div className="absolute -inset-6 bg-gradient-to-r from-primary/20 via-burgundy/20 to-gold/20 rounded-3xl blur-3xl group-hover:blur-[60px] transition-all duration-700 animate-float" />
              <div className="relative bg-gradient-to-br from-primary/10 via-burgundy/10 to-gold/10 rounded-[2rem] p-12 border-2 border-border/50 backdrop-blur-sm">
                <div className="space-y-8">
                  <div className="flex items-start gap-5 group/item hover:translate-x-2 transition-transform duration-300">
                    <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary/20 transition-colors">
                      <BookOpen className="w-7 h-7 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-bold text-2xl mb-2 font-playfair">Cărți și Publicații</h3>
                      <p className="text-muted-foreground font-lora text-lg">Valorificarea patrimoniului cultural prin editare</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-5 group/item hover:translate-x-2 transition-transform duration-300">
                    <div className="w-14 h-14 rounded-2xl bg-burgundy/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-burgundy/20 transition-colors">
                      <Video className="w-7 h-7 text-burgundy" />
                    </div>
                    <div>
                      <h3 className="font-bold text-2xl mb-2 font-playfair">Filme și Docudrama</h3>
                      <p className="text-muted-foreground font-lora text-lg">Producții cinematografice despre personalități și evenimente</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-5 group/item hover:translate-x-2 transition-transform duration-300">
                    <div className="w-14 h-14 rounded-2xl bg-gold/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-gold/20 transition-colors">
                      <Award className="w-7 h-7 text-gold" />
                    </div>
                    <div>
                      <h3 className="font-bold text-2xl mb-2 font-playfair">Proiecte Restituiri</h3>
                      <p className="text-muted-foreground font-lora text-lg">Readucerea la lumină a valorilor spirituale ortodoxe</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Media & Recognition Section */}
      <section className="py-24 px-4 bg-gradient-to-b from-cream/20 to-background">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="text-5xl md:text-6xl font-bold mb-8 text-primary font-playfair">
              Recunoaștere și Impact Mediatic
            </h2>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-4xl mx-auto font-lora">
              Activitatea noastră a fost recunoscută și prezentată în diverse publicații și emisiuni de prestigiu
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {mediaLinks.map((item, index) => (
              <a
                key={index}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group p-8 rounded-2xl bg-card/90 backdrop-blur-sm border-2 border-border/50 hover:border-primary/30 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                    {item.type === 'video' && <Video className="w-7 h-7 text-primary" />}
                    {item.type === 'article' && <BookOpen className="w-7 h-7 text-primary" />}
                    {item.type === 'award' && <Award className="w-7 h-7 text-primary" />}
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-bold mb-3 group-hover:text-primary transition-colors flex items-center gap-2 font-playfair">
                      {item.title}
                      <ExternalLink className="w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </h3>
                    <p className="text-muted-foreground leading-relaxed font-lora text-lg">
                      {item.description}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="relative rounded-[2rem] overflow-hidden p-16 md:p-24 text-center animate-fade-in bg-gradient-to-br from-primary/10 via-burgundy/5 to-background backdrop-blur-sm border-2 border-primary/20">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-burgundy/10 to-gold/20 opacity-50 -z-10" />
            <div className="absolute top-10 right-10 w-64 h-64 bg-primary/20 rounded-full blur-3xl animate-float" />
            <div className="absolute bottom-10 left-10 w-64 h-64 bg-burgundy/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }} />
            
            <h2 className="text-5xl md:text-6xl font-bold mb-8 text-primary font-playfair relative">
              Susțineți misiunea noastră
            </h2>
            <p className="text-xl md:text-2xl text-muted-foreground mb-10 max-w-3xl mx-auto font-lora leading-relaxed relative">
              Împreună putem păstra și promova valorile spirituale și culturale ale neamului românesc pentru generațiile viitoare
            </p>
            
            <Link to="/#contact">
              <Button size="lg" className="text-lg px-10 py-7 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-500 bg-primary hover:bg-primary/90 hover-scale hover-glow relative">
                Contactează-ne
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ROST;
